module.exports = __webpack_public_path__ + "static/media/no-audit-issues-posted.ed27fc23.svg";